exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-contact-tag__tag[data-v-7c340d57] {\n  margin-bottom: 0.71rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/Contact/src/components/Main/Contact/Tag.vue","/./src/components/Main/Contact/Tag.vue"],"names":[],"mappings":";AAyBA;EACE,uBAAA;CCxBD","file":"Tag.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../styles/variables.styl'\n.lxm-contact-tag__tag\n  margin-bottom: spacing-small\n",".lxm-contact-tag__tag {\n  margin-bottom: 0.71rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-7c340d57&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/Contact/Tag.vue
// module id = 654
// module chunks = 0